import { initComponent } from './core/init-component.js'
import { Swiper } from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

initComponent('.js-pdp-gallery', section => {
  const mobSliderEl = section.querySelector('.js-pdp-gallery-swiper-mob')
  const autoplaySpeed = parseInt(mobSliderEl?.dataset.autoplaySpeed) || 3000

  let swiperMob
  let swiperDt

  function initSwipers() {
    if (swiperMob) swiperMob.destroy(true, true)
    if (swiperDt) swiperDt.destroy(true, true)

    const mobSlider = section.querySelector('.js-pdp-gallery-swiper-mob')
    const mobPrevEl = section.querySelector('.js-slider-prev-mob')
    const mobNextEl = section.querySelector('.js-slider-next-mob')

    const dtSlider = section.querySelector('.js-pdp-gallery-swiper-dt')
    const dtPrevEl = section.querySelector('.js-slider-prev-dt')
    const dtNextEl = section.querySelector('.js-slider-next-dt')

    const swiperConfig = (prevEl, nextEl) => ({
      modules: [Navigation, Autoplay],
      slidesPerView: 1,
      slidesPerGroup: 1,
      freeMode: false,
      loop: true,
      speed: 300,
      navigation: { prevEl, nextEl },
      breakpoints: {
        1024: {
          speed: 0,
          allowTouchMove: false,
        }
      }
    })

    if (mobSlider) {
      swiperMob = new Swiper(mobSlider, swiperConfig(mobPrevEl, mobNextEl))
      swiperMob.on('slideChange', () => updateBackgroundColor(false))
    }

    if (dtSlider) {
      swiperDt = new Swiper(dtSlider, swiperConfig(dtPrevEl, dtNextEl))
      swiperDt.on('slideChange', () => updateBackgroundColor(false))
    }

    updateBackgroundColor(true)
  }

  initSwipers()

  section.addEventListener('gallery:reinit', () => {
    initSwipers()
  })

  // Extract background color from image
  function getBackgroundColorFromImage(img, callback) {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d', { willReadFrequently: true })
    if (!ctx) return

    const tempImg = new Image()
    tempImg.crossOrigin = 'anonymous'
    tempImg.src = img.src

    tempImg.onload = () => {
      canvas.width = tempImg.width
      canvas.height = tempImg.height
      ctx.drawImage(tempImg, 0, 0)
      // Sample from multiple points on the right side to get average color
      const rightX = tempImg.width - 10
      const pixels = [
        ctx.getImageData(rightX, Math.floor(tempImg.height * 0.25), 1, 1).data,
        ctx.getImageData(rightX, Math.floor(tempImg.height * 0.5), 1, 1).data,
        ctx.getImageData(rightX, Math.floor(tempImg.height * 0.75), 1, 1).data
      ]
      
      const avgR = Math.round(pixels.reduce((sum, p) => sum + p[0], 0) / 3)
      const avgG = Math.round(pixels.reduce((sum, p) => sum + p[1], 0) / 3)
      const avgB = Math.round(pixels.reduce((sum, p) => sum + p[2], 0) / 3)
      
      const color = `rgb(${avgR}, ${avgG}, ${avgB})`
      callback(color)
    }
  }

  function updateBackgroundColor(isInitial = false) {
    const swiper = window.innerWidth < 1024 ? swiperMob : swiperDt
    if (!swiper) return
    
    const gridContainer = document.querySelector('.js-pdp-grid-container')
    if (!gridContainer) return
    
    if (window.innerWidth <= 1023) {
      if (isInitial) {
        gridContainer.style.transition = 'none'
        gridContainer.style.backgroundColor = 'white'
        requestAnimationFrame(() => {
          gridContainer.style.transition = 'background-color 0.5s ease'
        })
      } else {
        gridContainer.style.backgroundColor = 'white'
      }
      return
    }
    
    const activeSlide = swiper.slides[swiper.realIndex]
    const img = activeSlide?.querySelector('img')
    
    if (img) {
      const applyColor = (color) => {
        if (gridContainer) {
          if (isInitial) {
            gridContainer.style.transition = 'none'
            gridContainer.style.backgroundColor = color
            requestAnimationFrame(() => {
              gridContainer.style.transition = 'background-color 0.5s ease'
            })
          } else {
            gridContainer.style.backgroundColor = color
          }
        }
      }

      if (img.complete) {
        getBackgroundColorFromImage(img, applyColor)
      } else {
        img.addEventListener('load', () => {
          getBackgroundColorFromImage(img, applyColor)
        }, { once: true })
      }
    }
  }

  return {
    unload() {
      if (swiperMob) swiperMob.destroy()
      if (swiperDt) swiperDt.destroy()
    }
  }
})
